import React, { useEffect, useRef } from "react";

const AddMenu = ({ setAddMenu, handleAddBulkUsers, handleAddUser, role }) => {
  const addMenuRef = useRef();
  useEffect(() => {
    function handleClickOutside(event) {
      if (addMenuRef.current && !addMenuRef.current.contains(event.target)) {
        setAddMenu((state) => !state);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [addMenuRef]);
  return (
    <div className="add-users" ref={addMenuRef}>
      <ul className="add-options">
        <li className="add-item" onClick={() => handleAddBulkUsers("bulk")}>
          Send Bulk Invitations
        </li>
        <li className="add-item" onClick={handleAddUser}>
          Invite {role === "Student" ? "Student" : "Instructor"}
        </li>
      </ul>
    </div>
  );
};

export default AddMenu;
